import React from 'react';
import pt from 'prop-types';
import { connect } from 'react-redux';
import actions from 'partners/actions';
import ViewLoading from 'components/view/loading';
import StoresPage from 'partners/components/pages/stores';

const mapStateToProps = (state) => ({
  collection: state.data.collection,
  session: state.session,
});

const mapDispatchToProps = (dispatch) => ({
  createStore: (data) => {
    return dispatch(actions.partner.createStore(data));
  },

  countDevStores: () => {
    return dispatch(actions.clients.count({ status: 'dev' }));
  },

  linkStores: (stores) => {
    return dispatch(actions.clients.link(stores));
  },

  disconnectStore: (id) => {
    return dispatch(actions.clients.disconnect(id));
  },

  transferOwnership: (id, email) => {
    return dispatch(actions.clients.transferOwnership(id, email));
  },

  cancelTransferOwnership: (id) => {
    return dispatch(actions.clients.cancelTransferOwnership(id));
  },

  fetchDeactivatedStores: () => {
    return dispatch(actions.clients.fetchDeactivated({ limit: 100 }));
  },

  deactivateStore: (id) => {
    return dispatch(actions.clients.deactivate(id));
  },

  reactivateStore: (id) => {
    return dispatch(actions.clients.reactivate(id));
  },
});

export class Stores extends React.Component {
  static propTypes = {
    createStore: pt.func,
    countDevStores: pt.func,
    linkStores: pt.func,
    disconnectStore: pt.func,
    transferOwnership: pt.func,
    cancelTransferOwnership: pt.func,
    fetchDeactivatedStores: pt.func,
    deactivateStore: pt.func,
    reactivateStore: pt.func,
  };

  static contextTypes = {
    isOwner: pt.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      devStoreCount: null,
      deactivatedStores: null,
      onCreateStore: this.onCreateStore.bind(this),
      onLinkStores: this.onLinkStores.bind(this),
      onDisconnectStore: this.onDisconnectStore.bind(this),
      onTransferOwnership: this.onTransferOwnership.bind(this),
      onCancelTransferOwnership: this.onCancelTransferOwnership.bind(this),
      onDeactivateStore: this.onDeactivateStore.bind(this),
      onReactivateStore: this.onReactivateStore.bind(this),
    };
  }

  componentDidMount() {
    this.fetchDevStoreCount();
    this.fetchDeactivatedStores();
  }

  async fetchDevStoreCount() {
    const { countDevStores } = this.props;
    const devStoreCount = await countDevStores();

    this.setState({ devStoreCount });
  }

  // Only the partner owner can see (and reactivate) deactivated stores
  async fetchDeactivatedStores() {
    const { fetchDeactivatedStores } = this.props;

    if (!this.context.isOwner) {
      return;
    }

    const deactivatedStores = await fetchDeactivatedStores();

    this.setState({ deactivatedStores });
  }

  async onCreateStore(name) {
    const { createStore } = this.props;

    this.setState({ loading: true });

    // create and connect dev store
    const result = await createStore({ store_name: name });

    this.setState({ loading: false });

    if (result && !result.error && !result.errors) {
      this.fetchDevStoreCount();
      return true;
    }

    return false;
  }

  async onLinkStores(stores) {
    const { linkStores } = this.props;

    this.setState({ loading: true });
    await linkStores(stores);
    this.setState({ loading: false });

    return true;
  }

  async onDisconnectStore(id) {
    const { disconnectStore } = this.props;

    this.setState({ loading: true });
    await disconnectStore(id);
    this.setState({ loading: false });

    return true;
  }

  async onTransferOwnership(id, email) {
    const { transferOwnership } = this.props;

    this.setState({ loading: true });
    const result = await transferOwnership(id, email);
    this.setState({ loading: false });

    return Boolean(result && !result.error && !result.errors);
  }

  async onCancelTransferOwnership(id) {
    const { cancelTransferOwnership } = this.props;

    this.setState({ loading: true });
    const result = await cancelTransferOwnership(id);
    this.setState({ loading: false });

    return Boolean(result && !result.error && !result.errors);
  }

  async onDeactivateStore(id) {
    const { deactivateStore } = this.props;

    this.setState({ loading: true });
    const result = await deactivateStore(id);
    this.setState({ loading: false });

    // Deactivating frees a development store slot
    await Promise.all([
      this.fetchDevStoreCount(),
      this.fetchDeactivatedStores(),
    ]);

    return Boolean(result && !result.error && !result.errors);
  }

  async onReactivateStore(id) {
    const { reactivateStore } = this.props;

    this.setState({ loading: true });
    const result = await reactivateStore(id);
    this.setState({ loading: false });

    await Promise.all([
      this.fetchDevStoreCount(),
      this.fetchDeactivatedStores(),
    ]);

    return Boolean(result && !result.error && !result.errors);
  }

  render() {
    const { loading } = this.state;

    if (loading) {
      return <ViewLoading />;
    }

    return <StoresPage {...this.props} {...this.state} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Stores);
